export default "__VITE_ASSET__CdVv3yBT__"